var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82572 16.7094L16.4099 6.12525C16.8096 5.7255 17.4584 5.7255 17.8582 6.12525L19.5761 7.84315C19.9758 8.2429 19.9758 8.89173 19.5761 9.29148L8.99092 19.8746C8.79924 20.0673 8.53889 20.1749 8.26727 20.1749H5.52539V17.4331C5.52539 17.1614 5.63302 16.9011 5.82572 16.7094Z",
    stroke: "#003541",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4941 8.03894L17.6614 11.2062",
    stroke: "#003541",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditModalIcon);
export default __webpack_public_path__ + "static/media/edit-modal-icon.a8f1bdf547e0eca1e78efedfd0e8d434.svg";
export { ForwardRef as ReactComponent };